
import DateFnsUtils from "@date-io/date-fns";
import { Avatar } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { withStyles } from "@material-ui/core/styles";
import SentimentDissatisfiedIcon from "@material-ui/icons/SentimentDissatisfied";
import SentimentSatisfiedIcon from "@material-ui/icons/SentimentSatisfied";
import SentimentVerySatisfiedIcon from "@material-ui/icons/SentimentVerySatisfied";
import Rating from "@material-ui/lab/Rating";
import {
  DatePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
  TimePicker,
} from "@material-ui/pickers";
import axios from "axios";
import Htmlparser from "html-react-parser";
import moment from "moment";
import PropTypes from "prop-types";
import qs from "qs";
import React, { Component, Fragment } from "react";
import { ReactMic } from "react-mic";
import io from "socket.io-client";
import swal from "sweetalert2";
import "./Chat.css";
import config from "./config";
import Slider from "./slider/Slider";
import { getFullTime, urlify } from "./strings";

const isIE = false || !!document.documentMode;

const StyledRating = withStyles({
  iconFilled: {
    color: "#FFB907",
  },
  iconHover: {
    color: "#FFB907",
  },
})(Rating);

const labels = {
  1: "لم تعجبني",
  2: "جيدة",
  3: "ممتازة",
  4: "جيدة جداً",
  5: "ممتازة",
};
const labels_en = {
  1: "Dislike",
  2: "Good",
  3: "Like",
  4: "Very Good",
  5: "Like",
};

const customIcons = {
  1: {
    icon: <SentimentDissatisfiedIcon style={{ fontSize: 75, color: "#ee5656" }} />,
    label: "لم تعجبني",
  },
  2: {
    icon: <SentimentSatisfiedIcon style={{ fontSize: 75, color: "#FFB326" }} />,
    label: "مقبولة",
  },
  3: {
    icon: <SentimentVerySatisfiedIcon style={{ fontSize: 75, color: "#12CA18" }} />,
    label: "ممتازة",
  },
};
const customIcons_en = {
  1: {
    icon: <SentimentDissatisfiedIcon style={{ fontSize: 75, color: "#ee5656" }} />,
    label: "Dislike",
  },
  2: {
    icon: <SentimentSatisfiedIcon style={{ fontSize: 75, color: "#FFB326" }} />,
    label: "Good",
  },
  3: {
    icon: <SentimentVerySatisfiedIcon style={{ fontSize: 75, color: "#12CA18" }} />,
    label: "Like",
  },
};

function IconContainer(props) {
  const { value, ...other } = props;
  return (
    <span {...other}>
      {props.chat_lang == "ar"
        ? customIcons[value].icon
        : customIcons_en[value].icon}
    </span>
  );
}
IconContainer.propTypes = {
  value: PropTypes.number.isRequired,
};

window.io = io;

const asyncLocalStorage = {
  setItem: function (key, value) {
    return Promise.resolve().then(function () {
      window.localStorage.setItem(key, value);
    });
  },
  getItem: function (key) {
    return Promise.resolve().then(function () {
      return window.localStorage.getItem(key);
    });
  },
};

class Chat extends Component {
  state = {};
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      closing: false,
      record: false,
      cancelRecord: false,
      loading: false,
      loadingMessages: false,
      userId: null,
      chatId: null,
      inputValue: "",
      messages: [],
      fileUploadState: "",
      fileUpload: "",
      file: null,
      displayButtons: true,
      selectedItemFromListRadio: "",
      selectedItemTextFromListRadio: "",
      changeDate: new Date(),
      maxDate: null,
      minDate: null,
      chat_lang: this.props.lang ? this.props.lang : "ar",
      token: this.props.token ? this.props.token : "",
      chatbotlang:
        !this.props.chatbotlang || typeof this.props.chatbotlang == "undefined"
          ? "ar"
          : this.props.chatbotlang,
      rating: 2,
      ratinghover: -1,
      Radio: "",
      hideInfoStInput: false,
      isLastMessagePassword: false,
      shouldActivateBot: 0,
      serviceType: null,
      showRecordingModal: false,
      recordingWarning: false,
      recordingTimeLeft: 120,
    };
    this.getBase64 = this.getBase64.bind(this);
    this.sendButtonAnswer = this.sendButtonAnswer.bind(this);
    this.onStop = this.onStop.bind(this);
    this.download = this.download.bind(this);
    this.takeASnap = this.takeASnap.bind(this);
    this.confirmExit = this.confirmExit.bind(this);
    this.changeFileAccepted = this.changeFileAccepted.bind(this);
    this.extendTime = this.extendTime.bind(this);
    this.handleRecordingClose = this.handleRecordingClose.bind(this);
  }

  socket = null;

  handleMinimizeKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      config.company == "MOID"
        ? this.sendMinimizetWindow()
        : this.props.onMinimize();
      this.state.shouldActivateBot === 1 &&
        this.activateBot(this.state.shouldActivateBot === 1);
    }
  };
  handleCloseKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.state.messages.length > 0
        ? this.sendExitWindow()
        : this.props.onClose();
    }
  };
  handleFileLabelKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      const fileInput = e.currentTarget.querySelector('input[type="file"]');
      if (fileInput) fileInput.click();
    }
  };

  componentDidUpdate(prevProps, prevState) {
    this.doUpdateLanguage();
    if (
      this.state.isLastMessagePassword &&
      this.state.messages[0] &&
      this.state.messages[0].type !== "password_req"
    )
      this.setState({
        isLastMessagePassword: false,
      });
    else if (
      !this.state.isLastMessagePassword &&
      this.state.messages[0] &&
      this.state.messages[0].type == "password_req"
    )
      this.setState({
        isLastMessagePassword: true,
      });
  const container = document.getElementById('infoSt-content');
  if (container) {
    container.scrollTop = container.scrollHeight;
  }


    if (!prevState.showRecordingModal && this.state.showRecordingModal) {
      setTimeout(() => {
        const firstButton = this.recordingModalRef?.querySelector('button');
        if (firstButton) firstButton.focus();
      }, 100);
      document.addEventListener('keydown', this.handleRecordingModalKeyDown);
    }
    else if (prevState.showRecordingModal && !this.state.showRecordingModal) {
      document.removeEventListener('keydown', this.handleRecordingModalKeyDown);
    }
  }

  handleRecordingModalKeyDown = (e) => {
    if (e.key === 'Tab') {
      const focusable = this.recordingModalRef?.querySelectorAll('button');
      if (!focusable || focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    if (e.key === 'Escape') {
      this.handleRecordingClose('cancel');
    }
  };

  componentWillUnmount() {
    if (this.recordingInterval) clearInterval(this.recordingInterval);
    if (this.timer) clearInterval(this.timer);
    document.removeEventListener('keydown', this.handleRecordingModalKeyDown);
  }

  extendTime = () => {
    const extendBtn = document.querySelector('.recording-extend-btn');
    if (extendBtn) {
      extendBtn.classList.add('recording-extend-shake');
      setTimeout(() => {
        extendBtn.classList.remove('recording-extend-shake');
      }, 500);
    }
    this.setState((prevState) => {
      const newTime = prevState.recordingTimeLeft + 120;
      return {
        recordingTimeLeft: newTime,
        recordingWarning: false,
      };
    }, () => {
      const timerEl = document.querySelector('.recording-timer-display');
      if (timerEl) {
        timerEl.classList.add('recording-timer-flash');
        setTimeout(() => {
          timerEl.classList.remove('recording-timer-flash');
        }, 600);
      }
    });
  };

  announceMessageToScreenReader = (messageText) => {
    const liveRegion = document.getElementById('chat-aria-live-region');
     if (liveRegion && messageText && messageText.trim()) {
      liveRegion.textContent = '';
      setTimeout(() => {
        liveRegion.textContent = messageText;
      }, 50);
    }
  };

  generateKey = () => {
    var S4 = () =>
      (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    let key = S4();
    return `key_${new Date().getTime()}_${key}`;
  };

  async handleNluCardRating(rate) {
    if (!this.socket) return;
    if (![0, 1].includes(rate)) return;
    let externaltoken = await asyncLocalStorage.getItem(
      "chatbotsystem_user_token"
    );
    this.socket.emit("send_message", {
      type: "plain_text",
      content: `rateNluCard${rate}`,
      channel: 1,
      action: null,
      lang: this.state.chatbotlang,
      hand_writing: false,
      token: externaltoken,
    });
  }

  async handleLiveAgentRating(nextValue) {
    if (!this.socket) return;
    await this.setState({ rating: nextValue, closing: false });
    let externaltoken = await asyncLocalStorage.getItem(
      "chatbotsystem_user_token"
    );
    this.socket.emit("send_message", {
      type: "plain_text",
      content: `rateLA-${this.state.rating}`,
      channel: 1,
      action: null,
      lang: this.state.chatbotlang,
      hand_writing: false,
      token: externaltoken,
    });
  }

  hideMessage = (predicate, message = null) => {
    let messages = this.state.messages;
    for (let i = 0; i < messages.length; i++) {
      if (predicate(messages[i])) {
        if (message) {
          message.time = messages[i].time;
          message.file_waiting = false;
          messages[i] = message;
        } else {
          messages[i].display = false;
          messages[i].file_waiting = false;
        }
        break;
      }
    }
    this.setState({ messages });
  };

  async onStarClick(nextValue, isFinalRating = false) {
    await this.setState({ rating: nextValue, closing: false });
    let externaltoken = await asyncLocalStorage.getItem(
      "chatbotsystem_user_token"
    );
    if (this.socket)
      this.socket.emit("send_message", {
        type: "plain_text",
        content: isFinalRating
          ? "ratefn-" + this.state.rating
          : "rating-" + this.state.rating,
        channel: 1,
        action: null,
        lang: this.state.chatbotlang,
        hand_writing: false,
        token: externaltoken,
      });
  }

  getActivateBotBtn(lang, withAnswer) {
    return {
      title: lang == "ar" ? "العودة للمجيب الذكي" : "Leave Live Agent",
      action: "activateBotBtn",
      classes: "",
      onClick: () => {
        if (!this.socket) return;
        this.activateBot(withAnswer);
        this.setState({
          displayButtons: false,
        });
      },
    };
  }

  async onStarClickClosing(newValue, isLiveAgent) {
    if (isLiveAgent) await this.handleLiveAgentRating(newValue);
    else await this.onStarClick(newValue, true);
  }

  async onStarHover(newHover, prevValue, name) {
    await this.setState({ ratinghover: newHover });
  }

  async onStarHoverOut(nextValue, prevValue, name) {
    await this.setState({ rating: 0 });
  }

  startRecording = () => {
    this.setState({
      showRecordingModal: true,
      record: true,
      recordingTimeLeft: 120,
      recordingWarning: false,
    });
    if (this.recordingInterval) clearInterval(this.recordingInterval);
    this.recordingInterval = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.recordingTimeLeft <= 0) {
          if (this.recordingInterval) clearInterval(this.recordingInterval);
          this.handleRecordingClose('confirm');
          return { recordingTimeLeft: 0 };
        }
        const newTime = prevState.recordingTimeLeft - 1;
        let warning = prevState.recordingWarning;
        if (newTime === 20 && !warning) {
          warning = true;
        }
        return {
          recordingTimeLeft: newTime,
          recordingWarning: warning,
        };
      });
    }, 1000);
  };

  handleRecordingClose = (action) => {
    if (this.recordingInterval) {
      clearInterval(this.recordingInterval);
      this.recordingInterval = null;
    }
    this.setState({ showRecordingModal: false, record: false });
    if (action === 'confirm') {
      this.stopRecording();
    } else if (action === 'cancel') {
      this.cancelRecording();
    }
  };

  stopRecording = () => {
    this.setState({ record: false });
  };

  cancelRecording = () => {
    this.setState({ cancelRecord: true, record: false });
  };

  onData(recordedBlob) {}
  async onStop(recordedBlob) {
    if (!this.state.cancelRecord) {
      const scope = this;
      console.info("recordedBlob is: ", recordedBlob);
      var result = {};
      var reader = new FileReader();
      reader.readAsDataURL(recordedBlob.blob);
      reader.onloadend = async () => {
        var base64data = reader.result;
        base64data = base64data.split(";base64,")[1];
        let base64text = qs.stringify({ text: base64data });
        result = await axios.post(
          `${config.network.socketHostPublic}/compress/v1/stt`,
          base64text,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        await scope.setState({ inputValue: result.data.result });
        scope.onSend();
      };
    } else this.setState({ cancelRecord: false });
  }

  gettoken = () => {
    return fetch(`${config.network.socketHostPublic}/gettoken`)
      .then((res) => {
        return res.json();
      })
      .catch(() => ({}));
  };

  askForCameraSnapShot() {
    if (navigator.mediaDevices === undefined) {
      navigator.mediaDevices = {};
    }
    if (navigator.mediaDevices.getUserMedia === undefined) {
      navigator.mediaDevices.getUserMedia = function (constraints) {
        var getUserMedia =
          navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
        if (!getUserMedia) {
          return Promise.reject(
            new Error("getUserMedia is not implemented in this browser")
          );
        }
        return new Promise(function (resolve, reject) {
          getUserMedia.call(navigator, constraints, resolve, reject);
        });
      };
    }
    navigator.mediaDevices
      .getUserMedia({ video: true, audio: false })
      .then((localStream) => {
        this.setState({ LocalStream: localStream });
        var video = document.getElementById("video-player");
        video.srcObject = new MediaStream(localStream);
        video.play();
      })
      .then(() => {
        const btn = document.getElementById("snapshot");
        btn.disabled = false;
        btn.onclick = (e) => {
          this.takeASnap().then(this.download);
        };
      })
      .catch((e) => console.log("please use the fiddle instead"));
  }

  takeASnap() {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    var vid = document.getElementById("video-player");
    canvas.width = vid.videoWidth;
    canvas.height = vid.videoHeight;
    ctx.drawImage(vid, 0, 0);
    return new Promise((res, rej) => {
      canvas.toBlob(res, "image/jpeg");
    });
  }

  download(blob) {
    let a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `screenshot${new Date().getTime()}.jpg`;
    document.body.appendChild(a);
    a.click();
    this.setState({ enableTakeSnap: false });
    this.hideMessage((obj) => obj.temp_message === "camera");
    this.getBase64(null, blob, a.download);
  }

  useCamera() {
    const use_camera_message = {
      action: null,
      chat_id: 0,
      content: {
        message:
          this.state.chat_lang == "ar"
            ? "التقط وارسل الصورة من خلال الكاميرا "
            : "Take a photo and send using camera",
        buttons: [
          {
            title:
              this.state.chat_lang == "ar" ? "القائمة الرئيسية" : "Main Menu",
            action: "مرحبا",
          },
        ],
      },
      lang: this.state.chat_lang,
      sequence: 23,
      time: new Date(),
      type: "camera",
      user_id: 1,
      display: true,
      temp_message: "camera",
    };
    let messages = this.state.messages;
    messages = [use_camera_message, ...messages];
    this.setState({ messages, enableTakeSnap: true });
    this.askForCameraSnapShot();
  }

  confirmExit() {
    if (!this.state.shouldActivateBot) return;
    this.activateBot(this.state.shouldActivateBot === 1);
  }

  async componentDidMount() {
    window.onbeforeunload = this.confirmExit;
    window.addEventListener("popstate", (event) => {
      window.localStorage.clear();
      this.confirmExit();
    });
    if (this.newMessage) this.newMessage.focus();
    this.setState({
      cameraSupported: !(typeof navigator.mediaDevices == "undefined"),
    });
    this.timer = setInterval(() => {
      for (let i = 0; i < this.state.messages.length; i++) {
        let message = this.state.messages[i];
        if (message.file_waiting) {
          let startDate = new Date(message.time);
          let endDate = new Date();
          let seconds = (endDate.getTime() - startDate.getTime()) / 1000;
          if (seconds > 60) {
            this.hideMessage(
              (obj) => obj.temp_message === message.temp_message
            );
          }
        }
      }
    }, 20000);
    let token = window.sessionStorage.getItem("chat_token");
    let chat_lang = window.sessionStorage.getItem("chat_lang");
    chat_lang =
      chat_lang && chat_lang != null && typeof chat_lang != "undefined"
        ? chat_lang
        : "ar";
    this.setState({
      loading: true,
      chat_lang,
    });
    let data = { token };
    if (!(token && token != "null" && token != "undefined")) {
      data = await this.gettoken();
    }
    token = data.token;
    window.localStorage.setItem("chat_token", token);
    window.localStorage.setItem("chat_lang", chat_lang);
    this.socket = io.connect(`${config.network.socketHostPublic}/user`, {
      reconnect: true,
      rejectUnauthorized: false,
      query: { token },
    });
    if (!this.socket) return;
    this.socket.on("connect", () => {
      this.setState({
        error: null,
      });
    });
    this.socket.on("connect_error", () => {
      this.setState({ error: "Network error" });
    });
    this.socket.on("connect_timeout", () => {
      this.setState({ error: "Network error" });
    });
    this.socket.on("reconnect", () => {
      this.setState({ error: null });
    });
    this.socket.on("reconnect_error", () => {
      this.setState({ error: "Network error" });
    });
    this.socket.on("reconnect_failed", () => {
      this.setState({ error: "Network error" });
    });
    this.socket.on("reconnect_attempt", () => {
      this.setState({ loading: true });
    });
    this.socket.on("reconnecting", () => this.setState({ loading: true }));
    this.socket.on("chat_error", ({ code, error, err_code }) => {
      window.localStorage.clear();
      this.props.onClose();
    });
    this.socket.on("chat_ready", ({ userId, chatId, session_id }) => {
      this.setState({
        loading: false,
        loadingMessages: true,
        userId,
        chatId,
        messages: [],
      });
      this.socket.emit("chat_messages", {
        chatId,
        session_id,
        limit: 1000,
      });
    });
    this.socket.on("chat_messages", async (data) => {
      let externaltoken = await asyncLocalStorage.getItem(
        "chatbotsystem_user_token"
      );
      if (this.props.interval == 1) {
        this.enforceNewSession();
      } else {
        this.socket.emit("send_message", {
          type: "plain_text",
          content: "control-hello",
          channel: 1,
          action: null,
          lang: this.state.chatbotlang,
          hand_writing: false,
          token: externaltoken,
        });
        this.setState({ messages: data.messages });
      }
      this.setState({ loadingMessages: false });
    });
    this.socket.on("new_message", async ({ message }) => {
      let { shouldActivateBot } = this.state;
      if (!shouldActivateBot) {
        switch (message.type) {
          case "startLiveAgent":
            shouldActivateBot = 1;
            break;
          case "startLiveAgent1":
            shouldActivateBot = 2;
            break;
          default:
            break;
        }
        this.setState({
          shouldActivateBot,
        });
      } else if (message.user_id === 1) {
        this.setState({
          shouldActivateBot: 0,
        });
      }
      try {
        this.setState({
          questionTextDisabled: message.content.questionTextDisabled || false,
        });
      } catch {}
      await this.hideMessage((obj) => obj.temp_message === "camera");
      if (this.state.LocalStream)
        this.state.LocalStream.getTracks().forEach((track) => track.stop());
      if (this.newMessage) this.newMessage.focus();
      message.display = true;
      if (message.fileName) {
        this.hideMessage(
          (obj) => obj.temp_message === message.fileName,
          message
        );
      } else {
        this.setState({
          chat_lang: message.lang,
        });
        window.localStorage.setItem("chat_lang", message.lang);
        if (message.type == "list") {
          this.setState({
            selectedItemFromListRadio: message.content.items
              ? message.content.items[0].action
              : "",
            selectedItemTextFromListRadio: message.content.items
              ? message.content.items[0].title
              : "",
          });
        } else if (message.type == "radio") {
          this.setState({
            selectedItemFromListRadio: message.content.radios
              ? message.content.radios[0].action
              : "",
            selectedItemTextFromListRadio: message.content.radios
              ? message.content.radios[0].title
              : "",
          });
        }
        let finalMessages = await this.state.messages;
        const { description, photoUrl, available_photopath } = getIntroMessageData(
          this.state.chat_lang
        );
        if (this.state.messages.length == 0) {
          let welcome_message = {
            action: null,
            chat_id: 0,
            content: {
              cards: [
                {
                  title: "",
                  description: description,
                  photoUrl:
                    (config.cssJsHostPublic ? config.cssJsHostPublic : "") +
                    "/chatbotinfost/webchat_images/" +
                    photoUrl,
                  buttons: [],
                },
              ],
            },
            lang: this.state.chatbotlang,
            sequence: -1,
            time: new Date(),
            type: "cards",
            user_id: 1,
            display: true,
            temp_message: "",
          };
          finalMessages = [welcome_message, ...finalMessages];
        }
        finalMessages = [message, ...finalMessages].filter(
          (obj) => obj.temp_message !== "waiting_response"
        );
        if (message.sender && message.sender == "user") {
          let waiting_obj = {
            action: null,
            chat_id: 0,
            content:
              (config.cssJsHostPublic ? config.cssJsHostPublic : "") +
              "/chatbotinfost/webchat_images/" +
              "dots2.gif",
            lang: this.state.chat_lang,
            sequence: 22,
            time: new Date(),
            type: ".gif",
            user_id: 1,
            display: true,
            temp_message: "waiting_response",
          };
          finalMessages = [waiting_obj, ...finalMessages];
        } else
          finalMessages = finalMessages.filter(
            (obj) => obj.temp_message !== "waiting_response"
          );
        this.setState((state) => ({
          messages: finalMessages,
          displayButtons:
            message.type.startsWith("startLiveAgent") || message.user_id == 1
              ? true
              : false,
          changeDate:
            message.type == "datetime"
              ? message.content.defaultValue
                ? new Date(message.content.defaultValue)
                : new Date()
              : new Date(),
          maxDate:
            message.type == "datetime"
              ? message.content.maxDate
                ? new Date(message.content.maxDate)
                : null
              : null,
          minDate:
            message.type == "datetime"
              ? message.content.minDate
                ? new Date(message.content.minDate)
                : null
              : null,
          Radio:
            message.type == "radio"
              ? message.content.radios
                ? message.content.radios[0].action
                : ""
              : "",
        }));
        if (message.user_id == 1)
          this.hideMessage((obj) => obj.temp_message === "waiting_response");
        if (message.content.happinessMeter) {
          try {
            window.happinessMeterWidgetServices({
              language: message.content.happinessMeter.language,
              serviceNameEn: message.content.happinessMeter.serviceNameEn,
              serviceNameAr: message.content.happinessMeter.serviceNameAr,
              fullSequenceCode: message.content.happinessMeter.fullSequenceCode,
              entitySequenceID: message.content.happinessMeter.entitySequenceID,
              mainServiceSequenceID:
                message.content.happinessMeter.mainServiceSequenceID,
              subserviceSequenceID:
                message.content.happinessMeter.subserviceSequenceID,
              subserviceComplementaryID:
                message.content.happinessMeter.subserviceComplementaryID,
              customerUserID: message.content.happinessMeter.customerUserID,
              transactionID: message.content.happinessMeter.transactionID,
            });
          } catch (ex) {
            console.log("window.happinessMeterWidgetServices====FAILED", ex);
          }
        }
        if (message.user_id === 1) {
          const botMessageText = typeof message.content === 'string'
            ? message.content
            : message.content?.message || '';
          if (botMessageText && botMessageText.trim()) {
            const cleanText = botMessageText.replace(/<[^>]*>/g, '').trim();
            if (cleanText) {
              const announcement = this.state.chat_lang === 'ar'
                ? `رسالة جديدة من البوت: ${cleanText}`
                : `New bot message: ${cleanText}`;
              this.announceMessageToScreenReader(announcement);
            }
          }
        }
      }
    });
    this.socket.on("end_upload", ({ message, uuid }) => {
      if (uuid !== this.state.userId) {
      }
    });
    this.socket.on("upload_error", ({ message, uuid }) => {
      if (uuid !== this.state.userId) {
        this.hideMessage((obj) => obj.temp_message === message.fileName);
      }
    });
    this.socket.on("cancel_running_chat", ({ chatId }) => {
      console.log(chatId, "cancelRunningChat");
      if (chatId) {
        this.setState({ chatId });
        this.activateBot(true);
      }
    });
  }

  doUpdateLanguage() {
    let oldlang = this.state.chatbotlang;
    let newlang =
      !window.chatbotlang || typeof window.chatbotlang == "undefined"
        ? "ar"
        : window.chatbotlang;
    if (oldlang != newlang) {
      this.setState({ chatbotlang: newlang });
      this.enforceNewSession();
    }
  }

  enforceNewSession() {
    this.props.resetInterval();
    if (this.socket)
      this.socket.emit("send_message", {
        type: "plain_text",
        content: "enforceNewSession",
        channel: 1,
        action: null,
        lang: this.state.chatbotlang,
        hand_writing: false,
        token: null,
      });
  }

  activateBot = (withAnswer) => {
    if (this.socket)
      this.socket.emit("chat_activate_bot", {
        chatId: this.state.chatId,
        withAnswer,
      });
  };

  sendExitWindow = async () => {
    let externaltoken = await asyncLocalStorage.getItem(
      "chatbotsystem_user_token"
    );
    this.confirmExit();
    if (this.socket)
      this.socket.emit("send_message", {
        type: "control-exitWindow",
        content: "control-exitWindow",
        channel: 1,
        action: null,
        lang: this.state.chatbotlang,
        hand_writing: false,
        token: externaltoken,
      });
  };

  sendMinimizetWindow = async () => {
    this.stopRecording();
    this.setState({ messages: [] });
    this.props.onMinimize();
  };

  onSend = async () => {
    let externaltoken = await asyncLocalStorage.getItem(
      "chatbotsystem_user_token"
    );
    if (this.socket)
      this.socket.emit("send_message", {
        type: "plain_text",
        content: this.state.Radio
          ? this.state.selectedItemTextFromListRadio +
            "/" +
            this.state.inputValue
          : this.state.inputValue,
        channel: 1,
        action:
          this.state.Radio != ""
            ? this.state.Radio + "##" + this.state.inputValue
            : null,
        lang: this.state.chatbotlang,
        hand_writing: true,
        token: externaltoken,
      });
    this.setState({
      inputValue: "",
      closing: false,
      Radio: this.state.Radio == "0" ? "" : this.state.Radio,
    });
  };

  selectCategory = (e) => {
    let titleAndAction = e.target.value.split("%%%%");
    try {
      this.setState({
        selectedItemTextFromListRadio: titleAndAction[0],
        selectedItemFromListRadio: titleAndAction[1],
        Radio: e.target.type == "radio" ? titleAndAction[1] : "",
      });
    } catch (e) {
      this.setState({
        selectedItemTextFromListRadio: "",
        selectedItemFromListRadio: "",
        Radio: "",
      });
    }
  };

  handleClickOutside = () => {
    this.props.onClose();
  };

  getBase64 = (e, File = null, FileName = null) => {
    if (File) {
      File.lastModifiedDate = new Date();
      File.name = FileName;
    }
    var file = !File ? e.target.files[0] : File;
    const fileExt = file.name.split(".").pop();
    const acceptedFile = [
      "jpg",
      "png",
      "pdf",
      "doc",
      "gif",
      "JPG",
      "PNG",
      "PDF",
      "DOC",
      "GIF",
    ].includes(fileExt);
    if (acceptedFile) {
      if (!File) e.target.value = null;
      if (file.size <= config.maxFileSize) {
        let fileReader = new FileReader();
        let slice = file.slice(0, config.maxFileSize);
        fileReader.readAsArrayBuffer(slice);
        fileReader.onload = () => {
          var arrayBuffer = fileReader.result;
          if (this.socket)
            this.socket.emit("slice_upload", {
              userId: this.state.userId,
              chatId: this.state.chatId,
              channel: 1,
              name: file.name,
              type: file.type,
              size: file.size,
              data: arrayBuffer,
              lang: this.state.chatbotlang,
              hand_writing: false,
            });
          let upload_message = {
            action: null,
            chat_id: this.state.chatId,
            content:
              (config.cssJsHostPublic ? config.cssJsHostPublic : "") +
              "/chatbotinfost/webchat_images/" +
              "Bubble-Preloader-1-1.gif",
            lang: this.state.chatbotlang,
            sequence: 22,
            time: new Date(),
            type: ".gif",
            user_id: this.state.userId,
            display: true,
            file_waiting: true,
            temp_message: file.name,
          };
          this.setState((state) => ({
            messages: [upload_message, ...state.messages],
          }));
          this.socket.on("request_slice_upload", (data) => {
            var place = data.currentSlice * config.maxFileSize;
            slice = file.slice(
              place,
              place + Math.min(config.maxFileSize, file.size - place)
            );
            fileReader.readAsArrayBuffer(slice);
          });
        };
        fileReader.onerror = function (error) {
          if (!File) e.target.value = null;
        };
      } else {
        const notAcceptableFileSize = {
          action: null,
          chat_id: 0,
          content: {
            message:
              this.state.chat_lang == "ar"
                ? "الحجم الأقصى للملف 5 ميغابايت"
                : "Sorry, Max File size is  5 MB",
            buttons: [
              {
                title:
                  this.state.chat_lang == "ar"
                    ? "إعادة المحاولة"
                    : "retry upload",
                action: "",
              },
              {
                title:
                  this.state.chat_lang == "ar"
                    ? "القائمة الرئيسية"
                    : "Main Menu",
                action: "مرحبا",
              },
            ],
          },
          lang: this.state.chatbotlang,
          sequence: 22,
          time: new Date(),
          type: "question",
          user_id: 1,
          display: true,
          temp_message: "",
        };
        let messages = this.state.messages;
        messages = [notAcceptableFileSize, ...messages];
        this.setState({ messages });
      }
    } else {
      const not_acceptable_file_type_message = {
        action: null,
        chat_id: 0,
        content: {
          message:
            this.state.chat_lang == "ar"
              ? "نوع الملف المراد رفعه غير مقبول "
              : "File type is not accepted",
          buttons: [
            {
              title:
                this.state.chat_lang == "ar" ? "القائمة الرئيسية" : "Main Menu",
              action: "مرحبا",
            },
          ],
        },
        lang: this.state.chatbotlang,
        sequence: 22,
        time: new Date(),
        type: "question",
        user_id: 1,
        display: true,
        temp_message: "",
      };
      let messages = this.state.messages;
      messages = [not_acceptable_file_type_message, ...messages];
      this.setState({ messages });
    }
  };

  onChange = (e) => {
    this.setState({ inputValue: e.target.value });
  };

  onKeyDown = (e) => {
    if (e.key === "Enter") {
      this.onSend();
    }
  };

render_Buttons = (buttons, index, func = 1,lang) => {
  return buttons
    ? buttons.map((object, idx) => {
        return (
          <button
           lang={lang}
            key={`${index}_btn_${idx}`}
            title={object.title}
            value={object.action}
            className={object.classes + " infoSt-buttons infoSt-butt "}
            parent_div={`${index + "_btn"}`}
            onClick={(e) => {
              if (object.onClick) {
                object.onClick();
                return;
              }
              if (func) {
                if (object.URL) window.open(object.URL, "_blank");
                this.sendButtonAnswer(e);
              } else this.sendButtonAnswerofCards(object);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.target.click();
              }
            }}
            tabIndex="0"
            role="button"
            aria-label={object.title}
            style={this.getStyleFromString(object.style)}
          >
            {object.title}
          </button>
        );
      })
    : "";
};

  renderSpinner = (...text) => (
    <div
      className={
        this.state.messages.length <= 2 && this.state.messages.length != 0
          ? "infoSt-content-onetime  infoSt-no-messages-content"
          : "infoSt-content infoSt-no-messages-content"
      }
      style={{ textAlign: "center" }}
    >
      <div className="webchat-loader" />
      <div>
        {text.map((el, index) => (
          <React.Fragment key={index}>
            {el}
            <br />
          </React.Fragment>
        ))}
      </div>
    </div>
  );

  renderNetworkError = (...text) => (
    <div
      className={"infoSt-content-err infoSt-no-messages-content"}
      style={{ textAlign: "center" }}
    >
      <div className="webchat-loader" />
      <div>
        <Fragment>
          {
            <img
              src={
                (config.cssJsHostPublic ? config.cssJsHostPublic : "") +
                "/chatbotinfost/webchat_images/connection_error.gif"
              }
              className="infoSt-img-err"
            />
          }
          <br />
          <span className="infoSt-span">
            {this.state.chatbotlang == "ar"
              ? "حدث خطأ في الاتصال"
              : "Error in connection"}{" "}
          </span>
        </Fragment>
        <Fragment>
          <br />
          <span className="infoSt-span">
            {this.state.chatbotlang == "ar"
              ? "جاري محاولة إعادة الاتصال"
              : "Attempting to reconnect chat server ...."}
          </span>
        </Fragment>
      </div>
    </div>
  );

  renderNoContent = () => (
    <div
      className={
        this.state.messages.length <= 2 && this.state.messages.length != 0
          ? "infoSt-content-onetime  infoSt-no-messages-content"
          : "infoSt-content infoSt-no-messages-content"
      }
    >
      <div className="infoSt-no-messages">
        <p className="infoSt-p">
          {this.state.chatbotlang == "ar"
            ? "... أهلاً وسهلاً بك"
            : "You are welcome ..."}{" "}
        </p>
      </div>
    </div>
  );

  changeFileAccepted() {
    this.state.messages &&
    this.state.messages.length > 0 &&
    this.state.messages[0] &&
    this.state.messages[0].content &&
    this.state.messages[0]?.content?.fileType &&
    this.state.messages[0]?.content?.fileType === "pdf"
      ? this.setState({
          serviceType: "ENotary",
        })
      : this.state.messages[0]?.content?.fileType === "elawyer"
      ? this.setState({
          serviceType: "elawyer",
        })
      : this.setState({
          serviceType: null,
        });
  }

  sendButtonAnswerofCards(object) {
    if (object.URL) window.open(object.URL, "_blank");
    if (object.action)
      if (this.socket)
        this.socket.emit("send_message", {
          type: "plain_text",
          content: object.realTitle ? object.realTitle : object.title,
          channel: 1,
          action: object.action,
          lang: this.state.chatbotlang,
          hand_writing: false,
        });
  }

  async sendButtonAnswer(e) {
    e.persist();
    let externaltoken = await asyncLocalStorage.getItem(
      "chatbotsystem_user_token"
    );
    if (e.target.value)
      if (this.socket)
        this.socket.emit("send_message", {
          type: "plain_text",
          content: e.target.realTitle ? e.target.realTitle : e.target.title,
          channel: 1,
          action: e.target.value,
          lang: this.state.chatbotlang,
          hand_writing: false,
          token: externaltoken,
        });
    this.setState({ displayButtons: false });
  }

  renderMessages = () => (
    <div
      className={
        this.state.messages.length <= 2 && this.state.messages.length != 0
          ? "infoSt-content-onetime1"
          : "infoSt-content1"
      }
    >
      {this.state.messages.length === 0 ? (
        <div className="infoSt-no-messages">
          {this.state.chatbotlang == "ar"
            ? "... أهلاً وسهلاً بك"
            : "You are welcome ..."}
        </div>
      ) : (
        this.state.messages.map(
          (
            {
              content,
              time,
              user_id,
              type,
              lang,
              temp_message,
              display,
              sequence,
            },
            index
          ) => {
            return display == null ||
              display == true ||
              typeof display == "undefined" ? (
              user_id != 1 ? (
                !temp_message ? (
                  <div key={`user-message-${index}`}>
                    <div
                      className={
                        this.state.userId === user_id
                          ? "infoSt-chat-user"
                          : "infoSt-chat-consultant"
                      }
                    >
                      {this.state.userId === user_id ? (
                        <Avatar className="infoSt-avatar">
                          <img
                            src={
                              (config.cssJsHostPublic
                                ? config.cssJsHostPublic
                                : "") + "/chatbotinfost/webchat_images/user.png"
                            }
                            className="infoSt-avatar-bot"
                          />
                        </Avatar>
                      ) : (
                        <Avatar className="infoSt-avatar">
                          <i className="fas fa-users-cog"></i>
                        </Avatar>
                      )}
                      <div
                        key={index}
                        className={`${
                          type == ".doc" || type == ".pdf" || type == "file"
                            ? "infoSt-message-icon"
                            : "infoSt-message"
                        }
            ${
                          this.state.userId === user_id
                            ? lang == "en"
                              ? "infoSt-ltr-my-message"
                              : "infoSt-my-message"
                            : "infoSt-consultant-message"
                        }`}
                      >
                        {type == ".png" ||
                        type == ".gif" ||
                        type == ".jpg" ||
                        type == "image" ? (
                          <a href={content} target="_blank">
                            <img src={content}></img>
                          </a>
                        ) : type == ".doc" ||
                          type == ".pdf" ||
                          type == "file" ? (
                          <a href={content} target="_blank">
                            <img
                              src={
                                config.network.socketHostPublic +
                                "/webchat_images/pdffile.png"
                              }
                              width="50px"
                              height="50px"
                            ></img>
                          </a>
                        ) : (
                          <div
                            className={
                              (lang == "en"
                                ? "infoSt-just-line-break-ltr"
                                : "infoSt-just-line-break") + "infoSt-p"
                            }
                          >
                            {!content || content == ""
                              ? "..."
                              : this.state.messages[index + 1] &&
                                this.state.messages[index + 1].type ===
                                  "password_req"
                              ? "* * * * * * *"
                              : content}
                          </div>
                        )}
                        <p className="infoSt-message-time infoSt-p">
                          {getFullTime(time)}
                        </p>
                      </div>
                    </div>
                    {index === 0 &&
                      type &&
                      type.startsWith("startLiveAgent") && (
                        <div
                          className="infoSt-dis"
                          key={`${index + "_btn"}`}
                          style={{
                            display:
                              `${index + "_btn"}` === "0_btn" &&
                              this.state.displayButtons
                                ? "flex"
                                : "none",
                          }}
                        >
                          <button
                            title={
                              lang == "ar"
                                ? "العودة للمجيب الذكي"
                                : "Leave Live Agent"
                            }
                            value={"activateBotBtn"}
                            className={" infoSt-buttons infoSt-butt "}
                            onClick={() => {
                              if (!this.socket) return;
                              this.activateBot(type.endsWith("1"));
                              this.setState({
                                displayButtons: false,
                              });
                            }}
                          >
                            {lang == "ar"
                              ? "العودة للمجيب الذكي"
                              : "Leave Live Agent"}
                          </button>
                        </div>
                      )}
                  </div>
                ) : (
                  <div key={`temp-message-${index}`}>
                    <div className={"infoSt-chat-user"}>
                      {
                        <Avatar className="infoSt-avatar">
                          <img
                            src={
                              (config.cssJsHostPublic
                                ? config.cssJsHostPublic
                                : "") + "/chatbotinfost/webchat_images/user.png"
                            }
                            className="infoSt-avatar-bot"
                          />
                        </Avatar>
                      }
                      <div
                        key={index}
                        className={
                          "infoSt-message infoSt-upload-loader-message"
                        }
                      >
                        <p className="infoSt-p">
                          {" "}
                          {<img src={content}></img>}
                          <h5
                            className="infoSt-h5"
                            style={{ textAlign: "center" }}
                          >
                            {this.state.chat_lang == "ar"
                              ? "جاري رفع الملف ..."
                              : "File is uploading ..."}
                          </h5>
                        </p>
                      </div>
                    </div>
                  </div>
                )
              ) : temp_message == "waiting_response" ? (
                <div key={`waiting-response-${index}`}>
                  <div className={"infoSt-chat-bot"}>
                    {
                      <Avatar className="infoSt-avatar">
                        {config.company == "MOID" ? (
                          <img
                            src={
                              (config.cssJsHostPublic
                                ? config.cssJsHostPublic
                                : "") +
                              "/chatbotinfost/webchat_images/AVATAR-04.png"
                            }
                            className="infoSt-avatar-bot2"
                          />
                        ) : (
                          <img
                            src={
                              (config.cssJsHostPublic
                                ? config.cssJsHostPublic
                                : "") +
                              "/chatbotinfost/webchat_images/chat2.gif"
                            }
                            className="infoSt-avatar-bot"
                          />
                        )}
                      </Avatar>
                    }
                    <div className={" infoSt-wait-loader-message"}>
                      <p className="infoSt-p"> {<img src={content}></img>}</p>
                    </div>
                  </div>
                </div>
              ) : [
                  "question",
                  "startLiveAgent",
                  "startLiveAgent1",
                ].includes(type) ? (
               <div key={`bot-message-${index}`} lang={lang}>
                  <div className={"infoSt-chat-bot"}>
                    <Avatar className="infoSt-avatar infoSt-avatarbot">
                      {config.company == "MOID" ? (
                        <img
                          src={
                            (config.cssJsHostPublic
                              ? config.cssJsHostPublic
                              : "") +
                            "/chatbotinfost/webchat_images/AVATAR-04.png"
                          }
                          className="infoSt-avatar-bot2"
                        />
                      ) : (
                        <img
                          src={
                            (config.cssJsHostPublic
                              ? config.cssJsHostPublic
                              : "") + "/chatbotinfost/webchat_images/chat2.gif"
                          }
                          className="infoSt-avatar-bot"
                        />
                      )}
                    </Avatar>
                    <div
                      key={index}
                      className={
                        lang == "en"
                          ? "infoSt-ltr-bot-message" + " infoSt-message-ltr"
                          : "infoSt-bot-message" + " infoSt-message"
                      }
                    >
                      <div
                        className={
                          lang == "en"
                            ? "infoSt-just-line-break-ltr"
                            : "infoSt-just-line-break"
                        }
                      >
                        <p className="infoSt-p">
                          {content.message
                            ? Htmlparser(urlify(content.message, lang))
                            : Htmlparser(urlify(content, lang))}
                        </p>
                      </div>
                      <p className="infoSt-message-time infoSt-p">
                        {getFullTime(time)}
                      </p>
                    </div>
                  </div>
                  {content.message ||
                  (type && type.startsWith("startLiveAgent")) ? (
                    <div
                      className="infoSt-dis"
                      key={`${index + "_btn"}`}
                      style={{
                        display:
                          `${index + "_btn"}` === "0_btn" &&
                          this.state.displayButtons
                            ? "flex"
                            : "none",
                      }}
                    >
                      {this.state.cameraSupported && content.camera ? (
                     <button
  className="infoSt-butlist infoSt-butt"
  parent_div={`${index + "_btn"}`}
  onClick={(e) => {
    this.useCamera();
  }}
  onKeyDown={(e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.useCamera();
    }
  }}
  tabIndex="0"
  role="button"
  aria-label={lang == "en" ? "Use Camera" : "استخدم الكاميرا"}
>
  {lang == "en" ? "Use Camera" : "استخدم الكاميرا"}
</button>
                      ) : (
                        ""
                      )}
                      {type && type.startsWith("startLiveAgent") && (
                        <button
                          title={
                            lang == "ar"
                              ? "العودة للمجيب الذكي"
                              : "Leave Live Agent"
                          }
                          value={"activateBotBtn"}
                          className={" infoSt-buttons infoSt-butt "}
                          onClick={() => {
                            if (!this.socket) return;
                            this.activateBot(type.endsWith("1"));
                            this.setState({
                              displayButtons: false,
                            });
                          }}
                        >
                          {lang == "ar"
                            ? "العودة للمجيب الذكي"
                            : "Leave Live Agent"}
                        </button>
                      )}
                      {this.render_Buttons(content.buttons, index)}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : type == "datetime" ? (
                <div key={`datetime-${index}`} className="row infoSt-date">
                  <span className="infoSt-span infoSt-choose">
                    {content.title}
                  </span>
                  <div
                    key={`${index + "_btn"}`}
                    style={{
                      display:
                        `${index + "_btn"}` === "0_btn" &&
                        this.state.displayButtons
                          ? "flex"
                          : "none",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                  >
                    <form>
                      {content.mode == "date" ? (
                        <DatePicker
                          autoOk
                          variant="static"
                          openTo={"date"}
                          dateFormat="YYYY-MM-DD"
                          value={this.state.changeDate}
                          {...(this.state.maxDate !== null && {
                            maxDate: this.state.maxDate,
                          })}
                          {...(this.state.minDate !== null && {
                            minDate: this.state.minDate,
                          })}
                          mask={(value) =>
                            value
                              ? [
                                  /\d/,
                                  /\d/,
                                  /\d/,
                                  /\d/,
                                  "/",
                                  /\d/,
                                  /\d/,
                                  "/",
                                  /\d/,
                                  /\d/,
                                ]
                              : []
                          }
                          onChange={(date) => {
                            this.setState({ changeDate: new Date(date) });
                          }}
                          mode="portrait"
                          style={{ margin: "-1rem auto" }}
                        />
                      ) : content.mode == "time" ? (
                        <TimePicker
                          autoOk
                          variant="static"
                          openTo={"time"}
                          dateFormat="YYYY-MM-DD"
                          value={this.state.changeDate}
                          {...(this.state.maxDate !== null && {
                            maxDate: this.state.maxDate,
                          })}
                          {...(this.state.minDate !== null && {
                            minDate: this.state.minDate,
                          })}
                          mask={(value) =>
                            value
                              ? [
                                  /\d/,
                                  /\d/,
                                  /\d/,
                                  /\d/,
                                  "/",
                                  /\d/,
                                  /\d/,
                                  "/",
                                  /\d/,
                                  /\d/,
                                ]
                              : []
                          }
                          onChange={(date) => {
                            this.setState({ changeDate: new Date(date) });
                          }}
                          mode="portrait"
                          style={{ margin: "-1rem auto" }}
                        />
                      ) : (
                        <DateTimePicker
                          autoOk
                          variant="static"
                          openTo={"date"}
                          dateFormat="YYYY-MM-DD"
                          value={this.state.changeDate}
                          {...(this.state.maxDate !== null && {
                            maxDate: this.state.maxDate,
                          })}
                          {...(this.state.minDate !== null && {
                            minDate: this.state.minDate,
                          })}
                          mask={(value) =>
                            value
                              ? [
                                  /\d/,
                                  /\d/,
                                  /\d/,
                                  /\d/,
                                  "/",
                                  /\d/,
                                  /\d/,
                                  "/",
                                  /\d/,
                                  /\d/,
                                ]
                              : []
                          }
                          onChange={(date) => {
                            this.setState({ changeDate: new Date(date) });
                          }}
                          mode="portrait"
                          style={{ margin: "-1rem auto" }}
                        />
                      )}
                    </form>
<button
  className="infoSt-buttons infoSt-butt"
  parent_div={`${index + "_btn"}`}
  onClick={(e) => {
    this.sendButtonAnswerofCards({
      title:
        content.mode == "date"
          ? moment(this.state.changeDate).format("YYYY-MM-DD")
          : content.mode == "time"
          ? moment(this.state.changeDate).format("hh:mm:ss")
          : moment(this.state.changeDate).format("YYYY-MM-DD hh:mm:ss"),
      action:
        content.mode == "date"
          ? "setField-" + moment(this.state.changeDate).format("YYYY/MM/DD")
          : content.mode == "time"
          ? "time-" + moment(this.state.changeDate).format("hh:mm:ss")
          : "datetime-" +
            moment(this.state.changeDate).format("YYYY-MM-DD hh:mm:ss"),
    });
  }}
  onKeyDown={(e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.sendButtonAnswerofCards({
        title:
          content.mode == "date"
            ? moment(this.state.changeDate).format("YYYY-MM-DD")
            : content.mode == "time"
            ? moment(this.state.changeDate).format("hh:mm:ss")
            : moment(this.state.changeDate).format("YYYY-MM-DD hh:mm:ss"),
        action:
          content.mode == "date"
            ? "setField-" + moment(this.state.changeDate).format("YYYY/MM/DD")
            : content.mode == "time"
            ? "time-" + moment(this.state.changeDate).format("hh:mm:ss")
            : "datetime-" +
              moment(this.state.changeDate).format("YYYY-MM-DD hh:mm:ss"),
      });
    }
  }}
  tabIndex="0"
  role="button"
  aria-label={content.buttonTitle || (this.state.chat_lang === "ar" ? "إرسال التاريخ" : "Send date")}
>
  {content.buttonTitle ? content.buttonTitle : "إرسال"}
</button>
                    {this.render_Buttons(
                      [
                        {
                          title:
                            this.state.chat_lang == "ar"
                              ? "القائمة الرئيسية"
                              : "Main Menu",
                          action: "مرحبا",
                        },
                      ],
                      index,
                      0
                    )}
                  </div>
                </div>
              ) : type == "radio" ? (
                <div key={`radio-${index}`} className="row infost-radioFlex">
                  <div className="infoSt-radio">
                    {!(`${index + "_btn"}` === "0_btn") ? (
                      <span className="infoSt-span infoSt-choose">
                        {content.title}
                      </span>
                    ) : (
                      ""
                    )}
                    <div
                      key={`${index + "_btn"}`}
                      style={{
                        display:
                          `${index + "_btn"}` === "0_btn" &&
                          this.state.displayButtons
                            ? "block"
                            : "none",
                      }}
                    >
                      <div>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">
                            {content.title}
                          </FormLabel>
                          <RadioGroup
                            defaultValue={
                              this.state.selectedItemTextFromListRadio +
                              "%%%%" +
                              this.state.selectedItemFromListRadio
                            }
                            aria-label="gender"
                            name="gender1"
                            onChange={this.selectCategory}
                          >
                            {content.radios
                              ? content.radios.map((object, index) => {
                                  return (
                                    <FormControlLabel
                                      type="radio"
                                      value={
                                        object.title + "%%%%" + object.action
                                      }
                                      control={<Radio />}
                                      label={object.title}
                                    />
                                  );
                                })
                              : ""}
                          </RadioGroup>
                        </FormControl>
                      </div>
                      {content.displayMainButtons && (
                        <div>
                          <button
                            className="infoSt-butlist infoSt-butt"
                            parent_div={`${index + "_btn"}`}
                            onClick={(e) => {
                              this.sendButtonAnswerofCards({
                                title: this.state.selectedItemTextFromListRadio,
                                action: this.state.selectedItemFromListRadio,
                              });
                            }}
                          >
                            {"ارسال"}
                          </button>
                          <div
                            className="infoSt-dis"
                            key={`${index + "_btn"}`}
                            style={{
                              display:
                                `${index + "_btn"}` === "0_btn" &&
                                this.state.displayButtons
                                  ? "flex"
                                  : "none",
                            }}
                          >
                            {this.render_Buttons(content.buttons, index, 0)}
                          </div>
                        </div>
                      )}
                      <div
                        className="infoSt-dis"
                        key={`${index + "_btn"}`}
                        style={{
                          display:
                            `${index + "_btn"}` === "0_btn" &&
                            this.state.displayButtons
                              ? "flex"
                              : "none",
                        }}
                      >
                        {this.render_Buttons(content.buttons, index, 0)}
                      </div>
                    </div>
                  </div>
                </div>
              ) : type == "camera" ? (
                <div key={`camera-${index}`} className="row infost-radioFlex">
                  <div className="infoSt-radio">
                    {!(`${index + "_btn"}` === "0_btn") ? (
                      <span className="infoSt-span infoSt-choose">
                        {content.message}
                      </span>
                    ) : (
                      ""
                    )}
                    <div>
                      <video
                        id="video-player"
                        width="100%"
                        height="100%"
                      ></video>
                      <canvas
                        id="drawCanvas"
                        class="hide"
                        width="100%"
                        height="100%"
                      ></canvas>
                    </div>
                    {
                      <div>
                     <button
  id="snapshot"
  className="infoSt-butlist infoSt-butt"
  parent_div={`${index + "_btn"}`}
  disabled={this.state.enableTakeSnap === false}
  onClick={(e) => {
    this.takeASnap().then(this.download);
  }}
  onKeyDown={(e) => {
    if ((e.key === 'Enter' || e.key === ' ') && !e.currentTarget.disabled) {
      e.preventDefault();
      this.takeASnap().then(this.download);
    }
  }}
  tabIndex="0"
  role="button"
  aria-label={
    this.state.chat_lang == "ar"
      ? "التقط وارسل الصورة"
      : "Take a photo and send"
  }
>
  {this.state.chat_lang == "ar"
    ? "التقط وارسل الصورة"
    : "Take a photo & send"}
</button>
                        <div
                          className="infoSt-dis"
                          key={`${index + "_btn"}`}
                          style={{
                            display:
                              `${index + "_btn"}` === "0_btn" &&
                              this.state.displayButtons
                                ? "flex"
                                : "none",
                          }}
                        >
                          {this.render_Buttons(content.buttons, index, 0)}
                        </div>
                      </div>
                    }
                  </div>
                </div>
              ) : type == "list" ? (
                <div key={`list-${index}`} className={"infoSt-chat-bot"}>
                  <Avatar className="infoSt-avatar infoSt-avatarbot">
                    {config.company == "MOID" ? (
                      <img
                        src={
                          (config.cssJsHostPublic
                            ? config.cssJsHostPublic
                            : "") +
                          "/chatbotinfost/webchat_images/AVATAR-04.png"
                        }
                        className="infoSt-avatar-bot2"
                      />
                    ) : (
                      <img
                        src={
                          (config.cssJsHostPublic
                            ? config.cssJsHostPublic
                            : "") + "/chatbotinfost/webchat_images/chat2.gif"
                        }
                        className="infoSt-avatar-bot"
                      />
                    )}
                  </Avatar>
                  <div className="row ">
                    <div className="ifoSt-category">
                      <div className="infoSt-message infoSt-ltr-bot-message">
                        <p classN="infoSt-p">
                          {" "}
                          {index + "_btn" === "0_btn" &&
                          this.state.displayButtons
                            ? content.title
                            : content.title
                            ? content.title
                            : content}
                        </p>
                      </div>
                      <div
                        className="infoSt-main"
                        key={`${index + "_btn"}`}
                        style={{
                          display:
                            `${index + "_btn"}` === "0_btn" &&
                            this.state.displayButtons
                              ? "block"
                              : "none",
                        }}
                      >
                        <div className="infoSt-select">
                          <select
                            className={
                              lang == "en"
                                ? "infoSt-ltr-option"
                                : "infoSt-option"
                            }
                            name="slct"
                            id="slct"
                            onChange={this.selectCategory}
                            defaultValue={
                              this.state.selectedItemTextFromListRadio +
                              "%%%%" +
                              this.state.selectedItemFromListRadio
                            }
                          >
                            {content.items
                              ? content.items.map((object, index) => {
                                  return (
                                    <option
                                      className="infoSt-Option"
                                      key={index}
                                      value={
                                        object.title + "%%%%" + object.action
                                      }
                                      type="list"
                                      parent_div={`${index + "_btn"}`}
                                    >
                                      {object.title}
                                    </option>
                                  );
                                })
                              : ""}
                          </select>
                        </div>
                   <button
  className="infoSt-butlist infoSt-butt"
  parent_div={`${index + "_btn"}`}
  onClick={(e) => {
    this.sendButtonAnswerofCards({
      title: this.state.selectedItemTextFromListRadio,
      action: this.state.selectedItemFromListRadio,
    });
  }}
  onKeyDown={(e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.sendButtonAnswerofCards({
        title: this.state.selectedItemTextFromListRadio,
        action: this.state.selectedItemFromListRadio,
      });
    }
  }}
  tabIndex="0"
  role="button"
  aria-label={this.state.chat_lang == "ar" ? "اختيار" : "Choose"}
>
  {this.state.chat_lang == "ar" ? "اختيار" : "Choose"}
</button>
                        {this.render_Buttons(
                          [
                            {
                              title:
                                this.state.chat_lang == "ar"
                                  ? "القائمة الرئيسية"
                                  : "Main Menu",
                              action: "مرحبا",
                            },
                          ],
                          index,
                          0
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : type == "rating" || type == "rating-LA" ? (
                <div key={`rating-${index}`} className="row infoSt-mrgRate">
                  <div className="infoSt-stars">
                    <h5 className="infoSt-h5">{content.message}</h5>
                    <Box
                      component="fieldset"
                      mb={3}
                      تColor="transparent"
                      style={{ marginBottom: "0" }}
                    >
                      <StyledRating
                        name="customized-icons"
                        defaultValue={2}
                        getLabelText={(value) => customIcons[value].label}
                        IconContainerComponent={IconContainer}
                        size="large"
                        max={3}
                        onChange={(event, newValue) => {
                          this.onStarClickClosing(
                            event.target.value,
                            type === "rating-LA"
                          );
                        }}
                        onChangeActive={(event, newHover) => {
                          this.onStarHover(newHover);
                        }}
                      />
                    </Box>
                    <h5 className="infoSt-h5" style={{ color: "#947940" }}>
                      {this.state.ratinghover !== -1 && (
                        <Box ml={2}>
                          {this.state.chat_lang == "ar"
                            ? labels[this.state.ratinghover]
                            : labels_en[this.state.ratinghover]}
                        </Box>
                      )}
                    </h5>
                    <div
                      className="infoSt-dis"
                      key={`${index + "_btn"}`}
                      style={{
                        display:
                          `${index + "_btn"}` === "0_btn" &&
                          this.state.displayButtons
                            ? "flex"
                            : "none",
                      }}
                    >
                      {this.render_Buttons(content.buttons, index)}
                    </div>
                  </div>
                </div>
              ) : type == "cards" || type === "nlu cards" ? (
                <div key={`cards-${index}`} className={"infoSt-chat-bot"}>
                  {
                    <Avatar className="infoSt-avatar infoSt-avatarbot">
                      {config.company == "MOID" ? (
                        <img
                          src={
                            (config.cssJsHostPublic
                              ? config.cssJsHostPublic
                              : "") +
                            "/chatbotinfost/webchat_images/AVATAR-04.png"
                          }
                          className="infoSt-avatar-bot2"
                        />
                      ) : (
                        <img
                          src={
                            (config.cssJsHostPublic
                              ? config.cssJsHostPublic
                              : "") + "/chatbotinfost/webchat_images/chat2.gif"
                          }
                          className="infoSt-avatar-bot"
                        />
                      )}
                    </Avatar>
                  }
                  {(content.cards &&
                    this.state.displayButtons &&
                    content.cards.length > 0 &&
                    index == 0) ||
                  sequence == -1 ? (
                    <Slider
                      onClickUp={() => this.handleNluCardRating(1)}
                      onClickDown={() => this.handleNluCardRating(0)}
                      hasEvaluation={type === "nlu cards"}
                      Cards={content.cards}
                      index={index}
                      lang={lang}
                      displayButtons={this.state.displayButtons}
                      sendButtonAnswerofCards={(title, value) =>
                        this.sendButtonAnswerofCards(title, value)
                      }
                      getStyleFromString={(style) =>
                        this.getStyleFromString(style)
                      }
                      generateKey={this.generateKey}
                    />
                  ) : (
                    <div
                      key={index}
                      className={
                        (lang == "en"
                          ? "infoSt-ltr-bot-message"
                          : "infoSt-bot-message") + " infoSt-message"
                      }
                    >
                      {" "}
                      <div
                        className={
                          lang == "en"
                            ? "infoSt-just-line-break-ltr"
                            : "infoSt-just-line-break"
                        }
                      >
                        <p className="infoSt-p">
                          {type === "nlu cards" &&
                          content.cards?.length &&
                          index !== 0
                            ? Htmlparser(urlify(content.cards[0].title, lang))
                            : typeof content === "string" &&
                              content !== "cards view"
                            ? content
                            : lang == "ar"
                            ? "   كيف أساعدك ؟"
                            : " ? How can I help you "}
                        </p>
                      </div>
                      <p className="infoSt-message-time infoSt-p">
                        {getFullTime(time)}
                      </p>
                    </div>
                  )}
                </div>
              ) : type == "webview" ? (
                content.mode == "iframe" ? (
                  <div
                    key={`webview-iframe-${index}`}
                    className=" infoSt-agent infoSt-mrht"
                  >
                    <div
                      class=" infoSt-mrht"
                      style={{
                        display:
                          `${index + "_btn"}` === "0_btn" &&
                          this.state.displayButtons
                            ? "flex"
                            : "none",
                        background: `url(${
                          config.cssJsHostPublic ? config.cssJsHostPublic : ``
                        }/chatbotinfost/webchat_images/pageloader11.gif) center center no-repeat`,
                      }}
                    >
                      {
                        <iframe
                          id="myiframe"
                          ref="myiframe"
                          src={content.message}
                          frameborder="0"
                          border="0"
                          cellspacing="0"
                          border-style="none"
                          width="330"
                          height="430"
                        >
                          {" "}
                        </iframe>
                      }
                      `
                    </div>
                    <div
                      className="infoSt-dis"
                      key={`${index + "_btn"}`}
                      style={{
                        display:
                          `${index + "_btn"}` === "0_btn" &&
                          this.state.displayButtons
                            ? "flex"
                            : "none",
                      }}
                    >
                      {this.render_Buttons(content.buttons, index)}
                    </div>
                  </div>
                ) : content.mode == "html" ? (
                  <div key={`webview-html-${index}`} className="row infoSt-mrht">
                    <div class="infoSt-ul">
                      {
                        <Avatar className="infoSt-avatar infoSt-avatarbot">
                          {config.company == "MOID" ? (
                            <img
                              src={
                                (config.cssJsHostPublic
                                  ? config.cssJsHostPublic
                                  : "") +
                                "/chatbotinfost/webchat_images/AVATAR-04.png"
                              }
                              className="infoSt-avatar-bot2"
                            />
                          ) : (
                            <img
                              src={
                                (config.cssJsHostPublic
                                  ? config.cssJsHostPublic
                                  : "") +
                                "/chatbotinfost/webchat_images/chat2.gif"
                              }
                              className="infoSt-avatar-bot"
                            />
                          )}
                        </Avatar>
                      }
                      {Htmlparser(urlify(content.message, lang))}
                      <div
                        className="infoSt-dis"
                        key={`${index + "_btn"}`}
                        style={{
                          display:
                            `${index + "_btn"}` === "0_btn" &&
                            this.state.displayButtons
                              ? "flex"
                              : "none",
                        }}
                      >
                        {this.render_Buttons(content.buttons, index)}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div key={`webview-default-${index}`} className="row infoSt-mrht"></div>
                )
              ) : (
                <div key={`default-message-${index}`}>
                  <div className={"infoSt-chat-bot"}>
                    {
                      <Avatar className="infoSt-avatar infoSt-avatarbot">
                        {config.company == "MOID" ? (
                          <img
                            src={
                              (config.cssJsHostPublic
                                ? config.cssJsHostPublic
                                : "") +
                              "/chatbotinfost/webchat_images/AVATAR-04.png"
                            }
                            className="infoSt-avatar-bot2"
                          />
                        ) : (
                          <img
                            src={
                              (config.cssJsHostPublic
                                ? config.cssJsHostPublic
                                : "") +
                              "/chatbotinfost/webchat_images/chat2.gif"
                            }
                            className="infoSt-avatar-bot"
                          />
                        )}
                      </Avatar>
                    }
                    <div
                      key={index}
                      className={`${
                        lang == "en"
                          ? "infoSt-ltr-bot-message"
                          : "infoSt-bot-message"
                      } ${
                        type == ".doc" || type == ".pdf" || type == "file"
                          ? "infoSt-message-icon"
                          : "infoSt-message"
                      }`}
                    >
                      {type == ".png" ||
                      type == ".gif" ||
                      type == ".jpg" ||
                      type == "image" ? (
                        <a
                          href={content.url ? content.url : content}
                          target="_blank"
                        >
                          <img src={content.url ? content.url : content}></img>
                        </a>
                      ) : type == ".doc" || type == ".pdf" || type == "file" ? (
                        <a
                          href={content.url ? content.url : content}
                          target="_blank"
                        >
                          <img
                            src={
                              config.network.socketHostPublic +
                              "/webchat_images/pdffile.png"
                            }
                            width="50px"
                            height="50px"
                          ></img>
                        </a>
                      ) : type == "control-minimizeWindow" ? (
                        this.props.onMinimize()
                      ) : (
                        <div
                          className={
                            lang == "en"
                              ? "infoSt-just-line-break-ltr"
                              : "infoSt-just-line-break"
                          }
                        >
                          {content && content.message
                            ? Htmlparser(urlify(content.message, lang))
                            : !content || content == ""
                            ? "..."
                            : Htmlparser(urlify(content, lang))}
                        </div>
                      )}
                      <p className="infoSt-message-time infoSt-p">
                        {getFullTime(time)}
                      </p>
                    </div>
                  </div>
                </div>
              )
            ) : (
              ""
            );
          }
        )
      )}
    </div>
  );

  getStyleFromString(StyleStr) {
    try {
      var StyleStrResult = JSON.parse(StyleStr);
    } catch (e) {
      return {};
    }
    return StyleStrResult;
  }

  render() {
    const stylehideclassicinput = { display: "none" };
    const isArabic = this.state.chatbotlang === "ar";
    const { available_photopath, hintMessage } = getIntroMessageData(this.state.chat_lang);
    const minimizeLabel = isArabic ? "تصغير نافذة الدردشة" : "Minimize chat window";
    const closeLabel = isArabic ? "إغلاق نافذة الدردشة" : "Close chat window";
    const attachLabel = isArabic ? "إرفاق ملف" : "Attach a file";
    const sendLabel = isArabic ? "إرسال الرسالة" : "Send message";
    const micLabel = isArabic ? "بدء التسجيل الصوتي" : "Start voice recording";
    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div
          id="chat-aria-live-region"
          aria-live="polite"
          aria-atomic="true"
          className="sr-only"
        />
        <div className="row">
          <div
            className={
              isArabic || config.company === "MOJ"
                ? "infoSt-container"
                : "infoSt-container-right"
            }
          >
            <div className="infoSt-backline">
              <img
                src={
                  (config.cssJsHostPublic ? config.cssJsHostPublic : "") +
                  "/chatbotinfost/webchat_images/Ad31.png"
                }
                className="infoSt-backav"
              />
            </div>
            <div className="infoSt-header">
              <div />
              <div
                className="infoSt-minimize"
                onClick={() => {
                  config.company == "MOID"
                    ? this.sendMinimizetWindow()
                    : this.props.onMinimize();
                  this.state.shouldActivateBot === 1 &&
                    this.activateBot(this.state.shouldActivateBot === 1);
                }}
                onKeyDown={this.handleMinimizeKeyDown}
                tabIndex="0"
                role="button"
                aria-label={minimizeLabel}
              >
                <img
                  src={
                    (config.cssJsHostPublic ? config.cssJsHostPublic : "") +
                    "/chatbotinfost/webchat_images/min.png"
                  }
                  alt=""
                />
              </div>
              <div
                className="infoSt-close1"
                onClick={() => {
                  this.state.messages.length > 0
                    ? this.sendExitWindow()
                    : this.props.onClose();
                }}
                onKeyDown={this.handleCloseKeyDown}
                tabIndex="0"
                role="button"
                aria-label={closeLabel}
              >
                <img
                  src={
                    (config.cssJsHostPublic ? config.cssJsHostPublic : "") +
                    "/chatbotinfost/webchat_images/x.png"
                  }
                  alt=""
                />
              </div>
              <div className=" infoStchat">
                {config.company == "MOID" ? (
                  <img
                    alt="MOEI AVATAR"
                    src={
                      (config.cssJsHostPublic ? config.cssJsHostPublic : "") +
                      "/chatbotinfost/webchat_images/MOID_AVATAR-04.png"
                    }
                    className="infoSt-av4"
                  />
                ) : (
                  <img
                    src={
                      (config.cssJsHostPublic ? config.cssJsHostPublic : "") +
                      "/chatbotinfost/webchat_images/Ad3.gif"
                    }
                    className="infoSt-ad"
                  />
                )}
              </div>
            </div>
            <div className="infoSt-mainavailability">
              <div className="infoSt-availability">
                <div className={this.state.chat_lang === "ar" ? "textAvailable" : "textAvailable-en textAvailable"}>
                  <img style={{ width: "60px" }}
                    src="/chatbotinfost/webchat_images/service.png"
                    className="availability"
                    alt="هذه الخدمة متوفرة 24/7"
                  />
                  <div style={{ display: "flex", justifyContent: "space-evenly", width: "75%", alignItems: "center" }}>
                    <div style={{ display: "flex" }}>
                      {this.state.chat_lang === "ar" ? <span className="sr-only">الخدمة متوفرة 24 ساعة على 7 أيام في الأسبوع. </span> : <span className="sr-only">Service is available 24 hours a day, 7 days a week.</span>}
                      <h1 style={{ fontFamily: "monospace" }}>24</h1>
                      <h1 style={{ fontFamily: "monospace" }}>/</h1>
                      <h1 style={{ fontFamily: "monospace" }}>7</h1>
                    </div>
                    {this.state.chat_lang === "ar" ? <p>هذه الخدمة متوفرة </p> : <p>This service is available </p>}
                  </div>
                </div>
                <p style={{ fontFamily: 'Droid Arabic Kufi', fontSize: "0.85rem", color: "#ee5656", marginTop: '8px' }}>
                  {hintMessage}
                </p>
              </div>
            </div>
            <div
              id="infoSt-content"
              className={
                this.state.messages.length <= 2 &&
                  this.state.messages.length != 0
                  ? "infoSt-content-onetime"
                  : "infoSt-content"
              }
            >
              <div ref={this.myRef} />
              <div className="infoSt-openlist">
                {(() => {
                  if (this.state.error) {
                    return this.renderNetworkError();
                  }
                  if (this.state.loading) {
                    return this.renderSpinner();
                  }
                  if (this.state.loadingMessages) {
                    return this.renderSpinner();
                  }
                  if (this.state.messages.length === 0) {
                    return this.renderNoContent();
                  }
                  return this.renderMessages();
                })()}
              </div>
            </div>
            <div
              dir={isArabic ? "ltr" : "rtl"}
              className="infoSt-input"
              style={{
                display: this.state.hideInfoStInput ? "none" : "flex",
              }}
            >
              <div>
                <label
                  className="infoSt-custom-file-upload infoSt-eclips"
                  role="button"
                  tabIndex="0"
                  aria-label={attachLabel}
                  onKeyDown={this.handleFileLabelKeyDown}
                >
                  <img
                    src={
                      (config.cssJsHostPublic ? config.cssJsHostPublic : "") +
                      "/chatbotinfost/webchat_images/fileClip.png"
                    }
                    className="infoSt-eclip"
                    alt={this.state.chat_lang === "ar" ? "إرفاق ملف" : "Attach file"}
                  />
                  <input
                    type="file"
                    name="fileUpload"
                    onClick={this.changeFileAccepted}
                    accept={
                      this.state.serviceType == "ENotary"
                        ? ".pdf"
                        : this.state.serviceType == "elawyer"
                          ? ".pdf,.jpg,.png"
                          : ".pdf,.doc,.jpg,.gif,.png"
                    }
                    style={stylehideclassicinput}
                    onChange={this.getBase64}
                    className="infoSt-inp"
                  />
                </label>
              </div>
              <div className="infoSt-input-wrapper">
                <img
                  src={
                    (config.cssJsHostPublic || "") +
                    "/chatbotinfost/webchat_images/pencil-icon.svg"
                  }
                  className="infoSt-input-icon"
                  aria-hidden="true"
                  alt={this.state.chat_lang === "ar" ? "اكتب رسالتك" : "type a message"}
                />
                <input
                  type={this.state.isLastMessagePassword ? "password" : "text"}
                  disabled={this.state.questionTextDisabled}
                  className={
                    this.state.chat_lang === "ar"
                      ? "infoSt-input-field"
                      : "infoSt-ltr-input-field"
                  }
                  value={this.state.inputValue}
                  onChange={this.onChange}
                  onKeyDown={this.onKeyDown}
                  placeholder={
                    this.state.chat_lang === "ar"
                      ? "...اكتب رسالتك"
                      : "Type your message..."
                  }
                  ref={(input) => {
                    this.newMessage = input;
                  }}
                  aria-label={
                    this.state.chat_lang === "ar"
                      ? "حقل إدخال الرسالة"
                      : "Message input field"
                  }
                />
              </div>
              {!isIE ? (
                <ReactMic
                  record={this.state.record}
                  echoCancellation={this.state.cancelRecord}
                  mimeType="audio/wav"
                  className="infoSt-canvas"
                  onStop={this.onStop}
                  onData={this.onData}
                />
              ) : (
                ""
              )}
              <button
                onClick={this.onSend}
                className="infoSt-sendbtn infoSt-butt"
                aria-label={sendLabel}
              >
                <img
                  src={
                    (config.cssJsHostPublic ? config.cssJsHostPublic : "") +
                    `/chatbotinfost/webchat_images/${
                      isArabic
                        ? "icons-02.png"
                        : "icons-03.png"
                    }`
                  }
                  className="infoSt-arr"
                  alt={this.state.chat_lang === "ar" ? "ارسال" : "send"}
                />
              </button>
              {!isIE && (
                <button
                  type="button"
                  onClick={this.startRecording}
                  className="infoSt-eclips"
                  aria-label={micLabel}
                >
                  <img
                    src={
                      (config.cssJsHostPublic || "") +
                      "/chatbotinfost/webchat_images/micro.png"
                    }
                    className="infoSt-arr2"
                    alt={this.state.chat_lang === "ar" ? "تسجيل صوتي" : "voice record"}
                  />
                </button>
              )}
            </div>
            {this.state.showRecordingModal && (
              <div
                role="dialog"
                aria-modal="true"
                aria-labelledby="recording-modal-title"
                className="recording-modal-overlay"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'rgba(0,0,0,0.5)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 10,
                }}
              >
                <div
                  ref={(el) => (this.recordingModalRef = el)}
                  tabIndex="-1"
                  className="recording-modal-content"
                  style={{
                    fontFamily: "Droid Arabic Kufi",
                    textAlign: 'center',
                    padding: '20px',
                    borderRadius: '8px',
                    backgroundColor: 'white',
                    maxWidth: '300px',
                    width: '90%',
                    margin: 'auto',
                    position: 'relative',
                    direction: this.state.chatbotlang === 'ar' ? 'rtl' : 'ltr',
                  }}
                >
                  <h3 id="recording-modal-title" style={{ margin: '0 0 15px' }}>
                    {this.state.chatbotlang === "ar" ? "عند الانتهاء اضغط على إرسال" : "Please press Send when finish recording"}
                  </h3>
                  <img
                    src={`${config.cssJsHostPublic || ""}/chatbotinfost/webchat_images/mico.png`}
                    width="80"
                    height="80"
                    alt={this.state.chatbotlang === "ar" ? "مايكروفون" : "Microphone"}
                    style={{ margin: '10px 0' }}
                  />
                  <p style={{ fontSize: '1.1em', color: this.state.recordingWarning ? '#ee5656' : '#333', display: "flex", gap: 10, justifyContent: "center", alignItems: "center", height: "20px", fontFamily: "monospace" }}>
                    {this.state.chatbotlang === "ar" ? "الوقت المتبقي: " : "Time remaining: "}
                    <h1 className="recording-timer-display">
                      {Math.floor(this.state.recordingTimeLeft / 60)}:
                      {(this.state.recordingTimeLeft % 60).toString().padStart(2, '0')}
                    </h1>
                  </p>
                  <div
                    aria-live="polite"
                    aria-atomic="true"
                    className="sr-only"
                  >
                    {this.state.chatbotlang === "ar"
                      ? `الوقت المتبقي: ${Math.floor(this.state.recordingTimeLeft / 60)} دقيقة و${this.state.recordingTimeLeft % 60} ثانية`
                      : `Time remaining: ${Math.floor(this.state.recordingTimeLeft / 60)} minutes and ${this.state.recordingTimeLeft % 60} seconds`}
                  </div>
                  {this.state.recordingWarning && (
                    <p style={{ color: '#ee5656', fontWeight: 'bold', margin: '8px 0' }}>
                      {this.state.chatbotlang === "ar" ? "ستُغلق النافذة خلال 20 ثانية!" : "Window will close in 20 seconds!"}
                    </p>
                  )}
                  <div style={{ marginTop: '15px' }}>
                    <button
                      type="button"
                      onClick={() => this.handleRecordingClose('confirm')}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          this.handleRecordingClose('confirm');
                        }
                      }}
                      tabIndex="0"
                      className="infoSt-butt"
                      style={{ margin: '5px', backgroundColor: '#C6AA78', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '4px' }}
                    >
                      {this.state.chatbotlang === "ar" ? "إرسال" : "Send"}
                    </button>
                    <button
                      type="button"
                      onClick={() => this.handleRecordingClose('cancel')}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          this.handleRecordingClose('cancel');
                        }
                      }}
                      tabIndex="0"
                      className="infoSt-butt"
                      style={{ margin: '5px', backgroundColor: '#C6AA78', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '4px' }}
                    >
                      {this.state.chatbotlang === "ar" ? "إلغاء" : "Cancel"}
                    </button>
                  </div>
                  <button
                    type="button"
                    onClick={this.extendTime}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this.extendTime();
                      }
                    }}
                    tabIndex="0"
                    className="infoSt-butt recording-extend-btn"
                    style={{
                      display: 'block',
                      margin: '15px auto 0',
                      backgroundColor: 'rgb(17 108 21)',
                      color: 'white',
                      border: 'none',
                      padding: '6px 12px',
                      borderRadius: '4px',
                    }}
                    aria-label={this.state.chatbotlang === "ar" ? "تمديد وقت التسجيل دقيقتين" : "Extend recording time by 2 minutes"}
                  >
                    {this.state.chatbotlang === "ar" ? "تمديد دقيقتين" : "Extend 2 min"}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </MuiPickersUtilsProvider>
    );
  }
}

export default Chat;

const content1 = {
  title: "الرجاء تحديد الامارة",
  displayMainButtons: false,
  radios: [
    { title: "أبو ظبي", action: "1" },
    { title: "دبي", action: "2" },
    { title: "عجمان", action: "3" },
    { title: " الشارقة", action: "4" },
    { title: "الفجيرة", action: "5" },
    { title: "راس الخيمة", action: "6" },
    { title: "أم القيوين", action: "7" },
  ],
};
const content2 = {
  title: "الرجاء تحديد الامارة",
  displayMainButtons: true,
  items: [
    { title: "أبو ظبي", action: "1" },
    { title: "دبي", action: "2" },
    { title: "عجمان", action: "3" },
    { title: " الشارقة", action: "4" },
    { title: "الفجيرة", action: "5" },
    { title: "راس الخيمة", action: "6" },
    { title: "أم القيوين", action: "7" },
  ],
};
const content3 = {
  title: "الرجاء التقط صورة وارسلها أو قم برفعها من خلال المرفقات",
  displayMainButtons: true,
  mode: "iframe",
};
const getIntroMessageData = (lang) => {
  let chatbotName, ministry, description, photoUrl, available_photopath, hintMessage;
  photoUrl = "mojLogo.png";
  if (lang === "ar") {
    chatbotName = "عادل";
    ministry = "أنظمة وخدمات وزارة العدل";
    description = `أهلاً بك في نظام المجيب الذكي (${chatbotName})، يمكنك كتابة سؤالك حول  ${ministry} أو الاختيار من قائمة الأنظمة.`;
    available_photopath = "/chatbotinfost/webchat_images/13.png";
    hintMessage = "";
  } else if (lang === "ur") {
    chatbotName = "عادل";
    ministry = "وزارت انصاف کے نظام اور خدمات";
    description = `ہمارے ورچوئل اسسٹنٹ (${chatbotName}) میں خوش آمدید، آپ ${ministry} کے بارے میں سوال لکھ سکتے ہیں یا سسٹمز مینو میں سے انتخاب کر سکتے ہیں۔`;
    available_photopath = "/chatbotinfost/webchat_images/ab.png";
    hintMessage = "This translation was generated using artificial intelligence. Review is recommended before official use.";
  } else {
    chatbotName = "Adeel";
    ministry = "Ministry of Justice.";
    description = `Welcome to Our Virtual Assistant (${chatbotName}), you can type your question about ${ministry} or choose from the Systems Menu.`;
    available_photopath = "/chatbotinfost/webchat_images/aa.png";
    hintMessage = "This translation was generated using artificial intelligence. Review is recommended before official use.";
  }
  return { description, photoUrl, available_photopath, hintMessage };
};